<template>
  <div class="">
    <div class="lazada-data-box">
      <p class="mb-0">
        <strong>Lazada Order Id :</strong>
        <span> {{ lazadaOrderId }}</span>
      </p>
      <p class="mb-0">
        <strong>Print AWB : </strong>
        <a @click="downloadDocument('printAWB')">
          {{ loading.printAWB ? 'Downloading...' : 'Download' }}
        </a>
      </p>
      <!-- <p class="mb-0">
        <strong>Shipping Label : </strong>
        <a @click="downloadDocument('shippingLabel')">
          {{ loading.shippingLabel ? 'Downloading...' : 'Download' }}
        </a>
      </p>
      <p class="mb-0">
        <strong>Carrier Manifest : </strong>
        <a @click="downloadDocument('carrierManifest')">
          {{ loading.carrierManifest ? 'Downloading...' : 'Download' }}
        </a>
      </p>
      <p class="mb-0">
        <strong>Invoice : </strong>
        <a @click="downloadDocument('invoice')">
          {{ loading.invoice ? 'Downloading...' : 'Download' }}
        </a>
      </p> -->
    </div>
  </div>
</template>

<script>
import LazadaOrderProvider from '@/resources/LazadaOrderProvider'

const LazadaOrderService = new LazadaOrderProvider()
export default {
  props: {
    orderId: {
      type: String,
      default: ''
    },
    lazadaOrderId: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      loading: {
        printAWB: false,
        shippingLabel: false,
        carrierManifest: false,
        invoice: false
      }
    }
  },
  methods: {
    async downloadDocument (documentType) {
      if (this.loading[documentType]) {
        return
      }

      try {
        this.loading[documentType] = true

        const { data } = await LazadaOrderService.getDocument({
          orderId: this.orderId,
          documentType
        })

        const url = data[0]?.docUrl || null
        if (!url) {
          this.$store.dispatch('Components/setSnackbar', {
            value: true,
            message: 'Document not found.',
            type: 'error'
          })
          return
        }

        const downloadLink = document.createElement('a')

        downloadLink.href = url
        downloadLink.setAttribute('target', '_blank')
        downloadLink.download = `${documentType}_${this.orderId}.pdf`
        downloadLink.click()
      } catch (error) {
        console.error(`ERROR: ${error.message}`)
      } finally {
        this.loading[documentType] = false
      }
    }
  }
}
</script>

<style scoped>
.lazada-data-box {
  font-size: 12px;
  margin-top: 10px;
  border-radius: 6px;
  padding: 10px;
  background-color: #f0f0f0;
}
</style>
